import React from 'react'

import { XStack } from 'tamagui'

import { Text } from '../Text'
import { Icon } from '../Icon'
import { Button } from '../Button/Button'

import type { GuildIconKeys } from '../GuildIcon/GuildIcon'

export type FlashMessageType = 'success' | 'info' | 'error'

const FLASH_ICON_COLORS: Record<FlashMessageType, string> = {
  success: '#ffffff',
  info: '#2563eb',
  error: '#ffffff',
}

const FLASH_ICONS: Record<FlashMessageType, GuildIconKeys> = {
  success: 'checkmark',
  info: 'star',
  error: 'dismiss',
}

const FLASH_TEXT_COLORS: Record<FlashMessageType, string> = {
  success: '#ffffff',
  info: '$color',
  error: '#ffffff',
}

const FLASH_BUTTON_BG: Record<FlashMessageType, string> = {
  success: 'rgba(255,255,255,0.25)',
  info: '$backgroundHover',
  error: 'rgba(255,255,255,0.25)',
}

const FLASH_DISMISS_COLORS: Record<FlashMessageType, string> = {
  success: '$color',
  info: '$color',
  error: '$color',
}

export function FlashContent({
  message,
  type,
  icon,
  onDismiss,
}: {
  message: string
  type: FlashMessageType
  icon?: GuildIconKeys
  onDismiss: () => void
}) {
  return (
    <XStack
      gap='$3'
      alignItems='center'
      paddingLeft='$2'
      maxWidth='calc(100vw - 32px)'
    >
      <Icon
        name={icon ?? FLASH_ICONS[type]}
        size='$5'
        color={FLASH_ICON_COLORS[type]}
        flexShrink={0}
      />

      <Text
        fontSize='$5'
        fontWeight='$5'
        color={FLASH_TEXT_COLORS[type]}
        flexShrink={1}
        numberOfLines={1}
      >
        {message}
      </Text>

      <Button
        onPress={onDismiss}
        secondary
        minHeight='$7'
        height='$7'
        width='$7'
        padding='$0'
        alignItems='center'
        justifyContent='center'
        marginLeft='$1'
        flexShrink={0}
        backgroundColor={FLASH_BUTTON_BG[type]}
        transform={[{ rotateZ: '45deg' }]}
      >
        <Icon name='add' color={FLASH_DISMISS_COLORS[type]} />
      </Button>
    </XStack>
  )
}
